// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"b36797ff","201":"9f0ac7b6","293":"6d6300b5","306":"10ed6a95","404":"1914c914","440":"1eed49ce","488":"06a4e569","618":"09bf7880"}[chunkId] + ".chunk.js";
};